export default __webpack_public_path__ + "static/media/american-power-and-gas-standard-logo.3393a5ee.png";